import { Injectable, signal } from '@angular/core';

@Injectable()
export class DescriptionDisclosure {
    private readonly keysState = signal<ReadonlySet<string>>(new Set());
    public readonly keys = this.keysState.asReadonly();

    public show(id: string): void {
        if (this.keysState().has(id)) return;
        this.keysState.update((keys) => new Set(keys).add(id));
    }

    public hide(id: string): void {
        this.keysState.update(
            (keys) => new Set([...keys].filter((key) => key !== id))
        );
    }

    public reset(): void {
        this.keysState.set(new Set());
    }
}
